<template>
  <div class="juou-card">
    <HpsfirProTable
      ref="tableRef"
      export-file-name="充值套餐管理"
      title="充值套餐管理"
      :paginations="{ pageSize: 10 }"
      :columns="columns"
      :get-data="getData"
      :on-add="addFun"
      :on-delete="deleteFun"
      :on-edit="updateFun"
      :loading="loading"
      :is-dangder-delete="true"
      :format-dangder-delete-info="formatDeleteInfo"
      row-key="id"
      :operates="operates"
      :add-init-values="addInitValue"
      :codition-init-values="conditionsInitValue"
    />
  </div>
</template>
<script lang="ts" setup>
import {
  useBaseAsync,
  type HpsfirProTableColumn,
  type HpsfirProTableData,
  type HpsfirProTableFilter,
  type HpsfirProTableGetDataFunction,
  type HpsfirProFormItem,
} from 'hpsfir-managebase-ui';

import { useApi } from '../../../hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';
import { normalizeBizTableColumns } from '@/utils/tableColumns';

const columns = ref<HpsfirProTableColumn[]>(normalizeBizTableColumns([]));
const tableRef = ref<any>();

const addInitValue = {
  // 默认值
};

const conditionsInitValue = {
  // 搜索条件默认值
};

// 初始化列配置
const init = useBaseAsync(() => {
  columns.value = normalizeBizTableColumns([
    {
      name: 'sequenceNumber',
      label: '序号',
      type: 'number',
      isCondition: true,
      rule: [{ required: true, message: '请输入排序序号' }],
      width: 120,
    },
    {
      name: 'amount',
      label: '充值金额',
      type: 'string',
      isCondition: true,
      rule: [{ required: true, message: '请输入充值金额' }],
      width: 120,
    },
    {
      name: 'beanCount',
      label: 'AI豆数',
      type: 'number',
      isCondition: true,
      rule: [{ required: true, message: '请输入赠送豆数' }],
      width: 120,
    },
    {
      name: 'purchaseLimit',
      label: '限购次数',
      type: 'number',
      min: 0,
      placeholder: '请输入限购次数（0不限购）',
      rule: [{ required: true, message: '请输入限购次数' }],
      width: 120,
    },
    {
      name: 'isHidden',
      label: '是否隐藏',
      type: 'select',
      options: [
        { label: '显示', value: 0 },
        { label: '隐藏', value: 1 },
      ],
      rule: [{ required: true, message: '请选择是否隐藏' }],
    },
    {
      name: 'createTime',
      label: '创建时间',
      type: 'string',
      hideEdit: true,
      hideCreate: true,
      width: 180,
    },
  ]);
});

const operates: any[] = [];

const loading = ref(false);

// 获取数据
const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    const res = await useApi().rechargePlanApi.pageRechargePlanrechargePlan({
      conditions: Object.entries(filter.conditions).reduce((conditions, [key, val]) => {
        if (val === null || val === undefined || val === '') {
          return conditions;
        }
        conditions[key] = val;
        return conditions;
      }, {} as any),
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },
    });

    const tableData: HpsfirProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data || [],
    };
    return tableData;
  } finally {
    loading.value = false;
  }
});

// 格式化删除确认信息
const formatDeleteInfo = (row: any) => `您确定要删除充值套餐"${row.amount || '未命名'}"吗？此操作不可恢复，请谨慎操作。`;

// 添加充值套餐
const addFun = useBaseAsync(async(data: any) => {
  await useApi().rechargePlanApi.addRechargePlanrechargePlan({
    rechargePlanAdminVo: {
      ...data,
    },
  });
  ElMessage.success('添加成功');
});

// 更新充值套餐
const updateFun = useBaseAsync(async(data: any) => {
  await useApi().rechargePlanApi.updateRechargePlanrechargePlan({
    rechargePlanAdminVo: {
      ...data,
    },
  });
  ElMessage.success('修改成功');
});

// 删除充值套餐
const deleteFun = useBaseAsync(async(data: any) => {
  await useApi().rechargePlanApi.delRechargePlanrechargePlan(data.id);
  ElMessage.success('删除成功');
});

// 页面初始化
init();
</script>
<style lang="scss" scoped>
</style>
